module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_3.5ba672d1.jpg";